export const SB_CATEGORIES = 'searchbarCategories'
export const FETCH = SB_CATEGORIES + '/FETCH'
